import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { format } from 'date-fns';
import { onValue, ref } from 'firebase/database';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Input } from 'reactstrap';

import CarouselStudent from './../ChecklistEditorStudent/CaruselStudent';
import PopupChecklistFile from './PopupChecklistFile';
import PopupComment from './PopupComment';
import iconNotebook from '../../assets/img/icon-notebook-stud.svg';
import {
  setDateVerificationExem,
  setCommentExem,
  getTeacher,
  setSupervisorDateCompleted,
  setExamenerDateCompleted,
  deleteCommentExem,
  subjectsObj,
} from '../../Common/Database';
import { database } from '../../Common/Firebase';
import { getProgressFile } from '../../redux/slices/uploadFileSlice';
import { getUserType } from '../../redux/slices/userSlice';
import StudentHomeworkItem from '../CreateHomework/StudentHomeworkItem';

import './../ChecklistEditorStudent/style.scss';
import classNames from 'classnames';
const ChecklistTeacher = () => {
  const [examItem, setExamItem] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupContentFile, setIsPopupContentFile] = useState({});
  const [isOpenCommentModal, setIsOpenCommentModal] = useState({});
  const [isTextareaContent, setIsTextareaContent] = useState('');
  const [currentParentIndex, setCurrentParentIndex] = useState(null);
  const [currentPointIndex, setCurrentPointIndex] = useState(null);
  const [nameTeacher, setNameTeacher] = useState(null);

  const fileProgressSelector = useSelector(getProgressFile);
  const userType = useSelector(getUserType);

  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const teacherDate = async () => {
      const response = await getTeacher(examItem.mail);
      const resp = response.val();

      if (resp) {
        setNameTeacher(resp.FIO);
      }
    };

    teacherDate();
  }, [examItem.mail]);

  useEffect(() => {
    setExamItem(location.state);
  }, [location]);

  useEffect(() => {
    const dbRef = ref(
      database,
      `Students/${
        location.state ? location.state.studentId : examItem.studentId
      }/materials/${location.state ? location.state.id : examItem.id}`,
    );

    const unsubscribe = onValue(dbRef, snapshot => {
      const obj = snapshot.val();
      setExamItem({
        ...obj,
        studentId: location.state ? location.state.studentId : examItem.studentId,
      });
    });

    return () => {
      unsubscribe();
    };
  }, [location]);

  const currentDate = format(new Date(), 'dd.MM.yyyy');

  const formatDateFromTimestamp = timestamp => {
    if (!timestamp || !timestamp.seconds) {
      return 'Invalid timestamp';
    }

    // Преобразовать объект Timestamp в объект Date
    const dateObject = new Date(timestamp.seconds * 1000);

    // Форматировать дату в формате "дд мм гггг"
    return format(dateObject, 'dd MM yyyy');
  };

  const openPopupFile = item => {
    setIsPopupContentFile(item);
    setIsPopupOpen(true);
  };

  const closePopupFile = () => {
    setIsPopupContentFile({});
    setIsPopupOpen(false);
  };

  const openPopupFileFunc = (e, file) => {
    if (!e.target.closest('.delet-file')) {
      openPopupFile(file);
    }
  };

  const openCommentModal = (parentIndex, pointIndex) => {
    setIsTextareaContent('');
    setCurrentParentIndex(parentIndex);
    setCurrentPointIndex(pointIndex);
    setIsOpenCommentModal({
      ...isOpenCommentModal,
      [`${parentIndex}-${pointIndex}`]: true,
    });
  };

  const closeCommentModal = () => {
    setIsTextareaContent('');
    setIsOpenCommentModal(false); // Закрываем модальное окно
  };

  const handleTextareaSave = comment => {
    if (comment && currentParentIndex !== null && currentPointIndex !== null) {
      setCommentExem(comment, location.state.studentId, examItem, currentParentIndex, currentPointIndex, setExamItem);
      closeCommentModal(false);
    }
  };

  const goToNotebook = (userMail, subject) => {
    if (userType === 'Teacher') {
      navigate(`/notebook/${userMail}/${subject}`);
    }
  };

  return (
    <div className="student-carusel teacher-page">
      <div className={fileProgressSelector > 0 ? 'progress-loader-wrap active' : 'progress-loader-wrap '}>
        <div className="progress-loader-item">
          <div className="progress-loader-content" style={{ width: fileProgressSelector + '%' }}>
            <span>{fileProgressSelector}%</span>
          </div>
        </div>
      </div>

      <CarouselStudent>
        <div key={0} className="materials-page checklist-page imageSlide container">
          <div className="data-course">
            <span className="subject">
              {t('subject')} {t(examItem.subject)}
            </span>
            <span className="checklist-numb">
              {t('Student')} {location.state.lastName} {location.state.firstName}
            </span>
          </div>
          <div className="title-wrap">
            <h1>
              {t('checklist')} №<span>{examItem.examNumber}</span>
            </h1>

            <div className="cource-name">
              <h3>
                {t('Cource name')}: <span>{examItem.name}</span>
              </h3>
            </div>

            <div className="date-wrap">
              <div className="wrap-picker">
                <span className="title">
                  <span>{t('start date')}: </span>
                  <div className="checked-item completed start-date">{examItem.startDateExam}</div>
                </span>
                <div className="wrap-picker-title"></div>
              </div>
              <div className="wrap-picker">
                <span className="title">
                  <span>{t('end date')}: </span>
                  <div className="checked-item completed end-date">
                    {examItem.courseCompletion &&
                    examItem.courseCompletion.studentEndExamCheked &&
                    examItem.courseCompletion.studentEndExam
                      ? examItem.courseCompletion.studentEndExam
                      : t('in progress')}
                  </div>
                </span>

                <div className="wrap-picker-title"></div>
              </div>
            </div>
          </div>
          <div className="checlist-content">
            <p>
              {t(
                'This is a control sheet. It contains tasks that you need to complete in turn. Put the date and your signature when you completed the task on the dash next to the task.',
              )}
            </p>
            <p>
              {t(
                'Whenever you come across a word that you do not understand or the meaning of which you are not sure, consult a dictionary.',
              )}
            </p>
            <p>{t('If you have any questions, please contact your supervisor.')}</p>
            <p>
              {t('A supervisor is the head of the course and is there to help you get the most out of the course.')}
            </p>
            <div className="purpose-wrap">
              <div className="cource-purpose">
                <h3>
                  {t('Purpose of the course')}: <span>{examItem.purpose}</span>
                </h3>
              </div>

              <div className="cource-purpose">
                <h3>
                  {t('Prerequisites')}: <span>{examItem.conditions}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>

        {examItem &&
          examItem.chapter &&
          examItem.chapter.length > 0 &&
          examItem.chapter.map((slide, index) => {
            return (
              <div key={index + 1} className="materials-page checklist-page imageSlide container">
                <div className="slide">
                  <div className="checklist-item">
                    <div className="data-course">
                      <span className="subject">
                        {t('subject')} {t(examItem.subject)}
                      </span>
                      <span className="checklist-numb">
                        {t('Student')} {location.state.lastName} {location.state.firstName}
                      </span>
                      {/* <span className="checklist-numb">
                        {t('checklist')} №{examItem.examNumber}
                      </span> */}
                    </div>
                    <h1>
                      {t('Chapter')} {index + 1}.
                    </h1>
                    <div className="checklist-item-top">
                      <h3>{t('materials')}:</h3>
                      <ul>
                        {slide.materials &&
                          slide.materials.map((materialItem, materIndex) => {
                            return materialItem.url ? (
                              <li
                                key={materialItem.id}
                                onClick={() => {
                                  if (materialItem.url) {
                                    window.open(materialItem.url, '_blank');
                                  }
                                }}
                              >
                                <span className="material-numb">{materIndex + 1}.</span>
                                <div className="icon">
                                  <img src={iconNotebook} alt="icon" />
                                </div>
                                <div
                                  className={classNames('wrap', {
                                    'without-link': materialItem.url === '',
                                  })}
                                >
                                  <p>{materialItem.title}</p>
                                </div>
                              </li>
                            ) : (
                              <li key={materialItem.id}>
                                <span className="material-numb">{materIndex + 1}.</span>
                                <div className="icon">
                                  <img src={iconNotebook} alt="icon" />
                                </div>
                                <div className={classNames('wrap')}>
                                  <Link
                                    style={{ color: 'black' }}
                                    onClick={() => console.log('sw')}
                                    to={`/materialView?id=${
                                      materialItem && materialItem.studentMaterial && materialItem.studentMaterial.id
                                    }`}
                                    target="_blank"
                                  >
                                    <p>{materialItem.title}</p>
                                  </Link>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </div>

                    {slide.points.map((pointItem, pointIndex) => {
                      return (
                        <div key={index + pointIndex + index + slide.chapterNum} className="checklist-item-content">
                          <div
                            className="title-wrap"
                            onClick={() => {
                              if (activeIndex === pointIndex + index + slide.chapterNum) {
                                setActiveIndex(null);
                              } else {
                                setActiveIndex(pointIndex + index + slide.chapterNum);
                              }
                            }}
                          >
                            <h3>{`${t('point')} №${pointIndex + 1}${pointItem.star ? '*' : ''}`}</h3>
                            <span
                              className={classNames('icon icon-chevron-down', {
                                revert: activeIndex === pointIndex + index + slide.chapterNum,
                              })}
                            ></span>
                          </div>

                          <div
                            className={`wrap-exum ${
                              activeIndex === pointIndex + index + slide.chapterNum ? 'open' : ''
                            }`}
                          >
                            <StudentHomeworkItem content={JSON.parse(pointItem.content)} checklist />
                          </div>

                          <div className="block-bottom">
                            <div className="data-row">
                              <div className="data-row-item">
                                <h4>{t('Task completed')}</h4>

                                <div className="checked-item completed">
                                  <Input
                                    className="homework-checkbox-input"
                                    checked={pointItem.itemComplited ? true : false}
                                    onChange={e => console.log(e)}
                                    type="checkbox"
                                  />
                                  {pointItem.itemComplited && pointItem.dataItemComplited
                                    ? pointItem.dataItemComplited
                                    : currentDate}
                                </div>
                              </div>

                              <div className="data-row-item">
                                <h4>{t('Task checked')}</h4>

                                <div className="checked-item checked">
                                  <Input
                                    className="homework-checkbox-input"
                                    checked={pointItem.itemVerification ? true : false}
                                    onChange={e =>
                                      setDateVerificationExem(e, location.state.studentId, examItem, index, pointIndex)
                                    }
                                    type="checkbox"
                                  />
                                  {pointItem.itemVerification && pointItem.dataItemVerification
                                    ? pointItem.dataItemVerification
                                    : currentDate}
                                </div>
                              </div>
                            </div>

                            <div className="block-buttons">
                              {pointItem.notebookLink && (
                                <Button
                                  className="btn btn-primary more comment"
                                  onClick={e =>
                                    goToNotebook(location.state.studentId, subjectsObj[location.state.subject])
                                  }
                                >
                                  {t('answer')}
                                </Button>
                              )}
                              <Button
                                className="btn btn-secondary more comment"
                                onClick={() => openCommentModal(index, pointIndex)}
                              >
                                {t('comment')}
                              </Button>
                            </div>
                          </div>

                          <div className="file-items">
                            {pointItem.fileItems &&
                              pointItem.fileItems.map((file, fileIndex) => (
                                <div className="wrap-img" onClick={e => openPopupFileFunc(e, file)}>
                                  <img key={fileIndex} src={file} alt={`file-${fileIndex}`} />
                                </div>
                              ))}
                          </div>

                          <div className="comments">
                            {pointItem.comments && (
                              <div>
                                <h5>{t('comments')}</h5>
                                {pointItem.comments.map((item, commentIndex) => (
                                  <div key={commentIndex} className="comment-wrap">
                                    <div className="wrap-teacher-name">
                                      <span className="teacher-name">{nameTeacher}</span>
                                      <span className="comment-time">{item.commentTime}</span>
                                    </div>
                                    <p>{item.pointComment}</p>
                                    <button
                                      className="delet-file"
                                      onClick={() =>
                                        deleteCommentExem(
                                          location.state.studentId,
                                          examItem,
                                          index,
                                          pointIndex,
                                          commentIndex,
                                          setExamItem,
                                        )
                                      }
                                    >
                                      <DeleteForeverIcon />
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>

                          <PopupComment
                            isOpen={isOpenCommentModal[`${index}-${pointIndex}`]}
                            onClose={() => closeCommentModal(index, pointIndex)}
                          >
                            <div className="popup-body">
                              <textarea
                                value={isTextareaContent}
                                onChange={e => setIsTextareaContent(e.target.value)}
                                placeholder={t('add comment')}
                              ></textarea>
                            </div>
                            <div className="popup-footer">
                              <button
                                className="btn btn-primary more"
                                onClick={() =>
                                  handleTextareaSave(isTextareaContent, currentParentIndex, currentPointIndex)
                                }
                              >
                                {t('add comment')}
                              </button>
                            </div>
                          </PopupComment>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <PopupChecklistFile isOpen={isPopupOpen} onClose={() => closePopupFile()}>
                  <div className="wrap-file-popup">
                    <img src={isPopupContentFile} alt="img-file" />
                  </div>
                </PopupChecklistFile>
              </div>
            );
          })}

        <div key={3} className="materials-page checklist-page imageSlide last-slide container">
          <div className="title-wrap">
            <div className="data-course">
              <span className="subject">
                {t('subject')} {t(examItem.subject)}
              </span>
              <span className="checklist-numb">
                {t('Student')} {location.state.lastName} {location.state.firstName}
              </span>
              {/* <span className="checklist-numb">
                {t('checklist')} №{examItem.examNumber}
              </span> */}
            </div>
            <h1>{t('Completion of the course')}</h1>

            <ul className="last-page-list">
              <li>
                <h3>{t('Student')}</h3>
                <p>
                  {t(
                    'I have studied all the material to be studied and completed all the exercises on this checklist, and I can apply all the information I have learned in this course.',
                  )}
                </p>
                <div className="data-row-item">
                  <h4>{t('date')}</h4>

                  <div className="checked-item completed">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.studentCheked ? true : false
                      }
                      onChange={e => console.log(e)}
                      type="checkbox"
                      readOnly
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.studentCheked &&
                    examItem.courseCompletion.student
                      ? examItem.courseCompletion.student
                      : currentDate}
                  </div>
                </div>
              </li>

              <li>
                <h3>{t('Supervisor')}</h3>
                <p>
                  {t(
                    'I certify that I have made every effort to teach this student and that he has studied all the material in this course and is able to apply the information he has learned.',
                  )}
                </p>
                <div className="data-row-item">
                  <h4>{t('date')}</h4>

                  <div className="checked-item exam">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.supervisorCheked
                          ? true
                          : false
                      }
                      onChange={e => setSupervisorDateCompleted(e, location.state.studentId, examItem)}
                      type="checkbox"
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.supervisorCheked &&
                    examItem.courseCompletion.supervisor
                      ? examItem.courseCompletion.supervisor
                      : currentDate}
                  </div>
                </div>
              </li>

              <li>
                <h3>{t('Course examiner')}</h3>
                <p>
                  {t(
                    'Checks that the checklist is completely filled out and that the student has completed everything required in this course.',
                  )}
                </p>
                <div className="data-row-item">
                  <h4>{t('date')}</h4>

                  <div className="checked-item checked">
                    <Input
                      className="homework-checkbox-input"
                      checked={
                        examItem && examItem.courseCompletion && examItem.courseCompletion.examenerCheked ? true : false
                      }
                      onChange={e => setExamenerDateCompleted(e, location.state.studentId, examItem)}
                      type="checkbox"
                    />
                    {examItem &&
                    examItem.courseCompletion &&
                    examItem.courseCompletion.examenerCheked &&
                    examItem.courseCompletion.examener
                      ? examItem.courseCompletion.examener
                      : currentDate}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </CarouselStudent>
    </div>
  );
};

export default ChecklistTeacher;
